import Route from "../../../router/Route";
import { RouterView } from "vue-router";
import Overview from "../pages/Overview.vue";
import Import from "../pages/Import.vue";

export default new Route(
	"targets",
	"/targets",
	RouterView,
	[
		new Route("targets.index", "", Overview, []),
		new Route("targets.import", "import", Import, []),
	],
	{ permissions: ["can_manage_targets"] }
);
